import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {ArbitraryEmailDto} from "../../generated-model/model";
import {Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class ArbitraryEmailResource {
  http = inject(HttpClient);

  public findAllEmail(): Observable<ArbitraryEmailDto[]> {
    return this.http.get<ArbitraryEmailDto[]>(`${environment.serverUrl}/api/arbitrary-email`);
  }

  save(item: ArbitraryEmailDto) {
    return this.http.post(`${environment.serverUrl}/api/arbitrary-email`, item);
  }
}
